import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromContainer from '../_reducers/container';

export const selectContainerState =
  createFeatureSelector<fromContainer.ContainerState>('containers');

export const selectAllContainers = createSelector(selectContainerState, fromContainer.selectAll);

export const selectContainerEntities = createSelector(
  selectContainerState,
  fromContainer.selectEntities
);

export const selectContainerById = (id: number) =>
  createSelector(selectContainerEntities, (entities) => entities[id]);

export const selectContainerTotal = createSelector(selectContainerState, fromContainer.selectTotal);
